import { ts } from '_core';

import { validate } from './helpers';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.TIME_SERIES_SCATTER_COMPARE,
    title: 'Time Series Scatter Plot',
    helpLabel: 'by987s57',
    generalAnalysisReportHelp: {
      document: ts.enums.UI_RESOURCE_TYPE_ENUM.TIME_SERIES,
      contentPath: `/${ts.enums.TIME_SERIES_ANALYSIS_TYPE_ENUM.ANALYSIS}`,
    },
    form: true,
    neededFiles: ['time_series_comparison'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.GENERAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.TIME_SERIES,
    ],

    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
